import React from 'react';
import { Container } from 'reactstrap';

//redux
import GraphList from './GraphList';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';

const Graph = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Gráficos' links={breadcrumbLinks} />
					<GraphList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Graph;